import { Search, X } from "lucide-react";

export default function SearchInput({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  size = "sm", // "sm" | "md"
  className = "",
}) {
  return (
    <div
      className={`flex items-center gap-2 px-3 rounded-xl border border-slate-200 
      bg-slate-50 focus-within:ring-2 focus-within:ring-blue-200 
      ${size === "sm" ? "h-9" : "h-8"} ${className}`}
    >
      {/* Search Icon */}
      <Search className="w-4 h-4 text-slate-700 shrink-0" />

      {/* Input */}
      <input
        type="text"
        placeholder={placeholder}
        className="flex-1 h-full bg-transparent outline-none text-sm placeholder:text-slate-500"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {/* Clear Button */}
      {value && (
        <button
          type="button"
          onClick={onClear}
          className="flex items-center justify-center w-6 h-6 rounded-md
                     text-slate-500 hover:text-slate-700 hover:bg-slate-200"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}




// import { Search, X } from "lucide-react";

// export default function SearchInput({
//   value,
//   onChange,
//   onClear,
//   placeholder = "Search...",
//   size = "sm",          // "sm" | "md"
//   className = "",
// }) {
//   return (
//     <div
//       className={`flex items-center gap-1 px-3 py-1 rounded-xl border border-slate-200 
//       bg-slate-50 focus-within:ring-2 focus-within:ring-blue-200 ${className}`}
//     >
//       <Search className="w-4 h-4 text-slate-800" />

//       <input
//         type="text"
//         placeholder={placeholder}
//         className={`bg-transparent outline-none placeholder:text-slate-700
//           ${size === "sm" ? "text-xs w-40" : "text-sm w-56 sm:w-64"}`}
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//       />

//       {value && (
//         <button
//           type="button"
//           onClick={onClear}
//           className="ml-1 text-slate-500 hover:text-slate-700"
//         >
//           <X className="w-3.5 h-3.5" />
//         </button>
//       )}
//     </div>
//   );
// }
